import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import GroupsTab from "../../components/admin/tabs/GroupsTab";
import GroupForm from "../../components/admin/forms/GroupForm";
import AdminLayout from "../../components/admin/AdminLayout";
import useGroupsData from "../../hooks/useGroupsData";
import useUsersData from "../../hooks/useUsersData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminGroupsPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const groupsData = useGroupsData(user);
  const usersData = useUsersData(user);
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh groups and users data
    groupsData.fetchGroups();
    usersData.fetchUsers();
  });

  const formatDate = (dateString) => {
    if (!dateString) return "Nunca";
    return new Date(dateString).toLocaleString("pt-BR");
  };

  // Handle update group wrapper
  const handleUpdateGroupWrapper = async (groupData) => {
    if (adminActions.editingGroup) {
      return await adminActions.handleUpdateGroup(adminActions.editingGroup.id, groupData);
    }
    throw new Error("Nenhum grupo sendo editado");
  };

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Gerenciar Grupos">
      <GroupsTab
        groups={groupsData.groups}
        loading={groupsData.loading}
        error={groupsData.error}
        onEditGroup={adminActions.handleEditGroup}
        onDeleteGroup={adminActions.handleDeleteGroup}
        onShowGroupForm={() => adminActions.setShowGroupForm(true)}
        formatDate={formatDate}
        groupSearchTerm={groupsData.groupSearchTerm}
        setGroupSearchTerm={groupsData.setGroupSearchTerm}
        groupDomain={groupsData.groupDomain}
        setGroupDomain={groupsData.setGroupDomain}
        onGroupSearch={() =>
          groupsData.fetchGroups(1, groupsData.groupSearchTerm, groupsData.groupDomain)
        }
        onClearGroupSearch={() => {
          groupsData.setGroupSearchTerm("");
          groupsData.setGroupDomain("");
          groupsData.fetchGroups(1, "", "");
        }}
        onSearchKeyPress={(e) => {
          if (e.key === "Enter") {
            groupsData.fetchGroups(1, groupsData.groupSearchTerm, groupsData.groupDomain);
          }
        }}
        onOpenGroupForm={(group) => adminActions.handleEditGroup(group)}
      />

      {/* Group Form Modal */}
      {adminActions.showGroupForm && (
        <GroupForm
          onClose={() => {
            adminActions.setShowGroupForm(false);
            adminActions.setEditingGroup(null);
          }}
          onSubmit={
            adminActions.editingGroup ? handleUpdateGroupWrapper : adminActions.handleCreateGroup
          }
          group={adminActions.editingGroup}
          users={usersData.users}
        />
      )}
    </AdminLayout>
  );
};

export default AdminGroupsPage;
